export const UI_SCALE_STORAGE_KEY = 'app_ui_scale';
export const DEFAULT_UI_SCALE = 'default';

export const UI_SCALE_PRESETS = [
  { key: 'ultra-compact', percent: 70, value: 0.7, labelKey: 'header.uiScale.ultraCompact' },
  { key: 'compact', percent: 85, value: 0.85, labelKey: 'header.uiScale.compact' },
  { key: 'default', percent: 100, value: 1, labelKey: 'header.uiScale.default' },
  { key: 'large', percent: 115, value: 1.15, labelKey: 'header.uiScale.large' },
  { key: 'extra-large', percent: 130, value: 1.3, labelKey: 'header.uiScale.extraLarge' },
];

const PRESET_BY_KEY = new Map(UI_SCALE_PRESETS.map((preset) => [preset.key, preset]));

function getDefaultStorage() {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

function getDefaultScaleTarget() {
  try {
    return typeof document === 'undefined' ? null : document.documentElement;
  } catch {
    return null;
  }
}

export function normalizeUiScale(value) {
  return PRESET_BY_KEY.has(value) ? value : DEFAULT_UI_SCALE;
}

export function getUiScalePreset(value) {
  return PRESET_BY_KEY.get(normalizeUiScale(value)) || PRESET_BY_KEY.get(DEFAULT_UI_SCALE);
}

export function getStoredUiScale(storage) {
  const targetStorage = arguments.length > 0 ? storage : getDefaultStorage();

  try {
    return normalizeUiScale(targetStorage?.getItem?.(UI_SCALE_STORAGE_KEY));
  } catch {
    return DEFAULT_UI_SCALE;
  }
}

export function setStoredUiScale(value, storage) {
  const normalized = normalizeUiScale(value);
  const targetStorage = arguments.length > 1 ? storage : getDefaultStorage();

  try {
    if (normalized === DEFAULT_UI_SCALE) {
      targetStorage?.removeItem?.(UI_SCALE_STORAGE_KEY);
      return normalized;
    }

    targetStorage?.setItem?.(UI_SCALE_STORAGE_KEY, normalized);
  } catch {
    // Ignore storage failures; in-memory UI state still works for the current page.
  }

  return normalized;
}

export function applyUiScaleToDocument(value, target) {
  const preset = getUiScalePreset(value);
  const scaleTarget = arguments.length > 1 ? target : getDefaultScaleTarget();

  if (!scaleTarget) {
    return preset.key;
  }

  try {
    scaleTarget.setAttribute('data-ui-scale', preset.key);
    scaleTarget.style.setProperty('--app-ui-scale', String(preset.value));
  } catch {
    // Ignore DOM failures in non-browser/test environments.
  }

  return preset.key;
}
